
import { TableCell, TableRow, Tooltip, Chip, Button, IconButton, Collapse, Box, Typography, TableBody, TableHead, Table, Grid, Avatar, } from '@mui/material';
import { panelsActive, panelsRemoveActive } from '../../../../reducers/panels/panelsReducer';
import { nodesActive, nodesRemoveActive } from '../../../../reducers/nodes/nodesReducer';
import { gatewaysActive, gatewaysRemoveActive } from '../../../../reducers/gateways/gatewaysReducers';
import { useDispatch } from 'react-redux';
import { startContractsActive } from '../../../../reducers/contracts/contractsActions';
//prubeas
import { useFetch } from '../../../../hooks/useFetch';
import React from 'react';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import { buildOtherPanelInfoQuery } from '../../../../helpers/panels/buildOtherPanelInfoQuery';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { countPanelsWithProfile } from '../../../../helpers/panels/countPanelsWithProfile';
import theme from '../../../../material-ui/theme';
import { ArrowRightAlt } from '@mui/icons-material';


export const PanelsProfileInfoRow = ({ contract, activeContractData, countPanelsPerFirmware = () => [], countNodesPerFirmware = () => [] }) => {

  const dispatch = useDispatch();

  const handleClick = (id) => {
    dispatch(startContractsActive(id))
  }
  const activeContractId = activeContractData.id;

  const handleActivatePanels = (Ids) => {
    if (Ids.length > 0 && activeContractId === contract.id) {
      dispatch(panelsRemoveActive());
      dispatch(panelsActive(Ids.map(id => ({ id }))));
    }
  };

  const handleActivateNodes = (Ids) => {
    if (Ids.length > 0 && activeContractId === contract.id) {
      dispatch(nodesRemoveActive());
      dispatch(nodesActive(Ids.map(id => ({ id }))));
    }
  };

  const handleActivateGateways = (Ids) => {
    if (Ids.length > 0 && activeContractId === contract.id) {
      dispatch(gatewaysRemoveActive());
      dispatch(gatewaysActive(Ids.map(id => ({ id }))));
    }
  };

  //PRUEBA
  const { data, loading } = useFetch(`contract/${activeContractId}/${buildOtherPanelInfoQuery(activeContractData.u6me2, activeContractData.differentialCircutor, activeContractData.additionalPanelOutputs)}`);
  const dataForU6me2 = data?.map(item => ({
    id: item.id,
    profiles: [
      item.u6me2_profile1_id,
      item.u6me2_profile2_id,
      item.u6me2_profile3_id,
      item.u6me2_profile4_id,
    ]
  }));
  const dataForDifferentialCircutor = data?.map(item => ({
    id: item.id,
    profiles: [
      item.circutor_profile_id,
    ]
  }));
  const dataForRelayAdditionalOutputs = data?.map(item => ({
    id: item.id,
    profiles: [
      item.on_off_schedule5_profile_id,
      item.on_off_schedule6_profile_id,
      item.on_off_schedule7_profile_id,
      item.on_off_schedule8_profile_id,
    ]
  }));
  const dataForDigitalAdditionalOutputs = data?.map(item => ({
    id: item.id,
    profiles: [
      item.on_off_schedule5_profile_type,
      item.on_off_schedule6_profile_type,
      item.on_off_schedule7_profile_type,
      item.on_off_schedule8_profile_type,
    ]
  }));
  const pruebaCuenta = data && data.length > 0
    ? countPanelsWithProfile(dataForU6me2)
    : "0";
  /**
   * 
  useEffect(() => {
    console.log(countPanelsPerFirmware().length)
  }, [data])
  */
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <TableRow selected={activeContractId === contract.id} sx={{ '& > *': { borderBottom: 'unset' } }}>

        <TableCell style={{ borderRight: '1px solid black' }}>
          {contract?.id === activeContractId && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? < KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
          <Button
            onClick={() => {
              return handleClick(contract.id)
            }}
            variant="outlined"
            disabled={activeContractId === contract.id}
            style={{
              fontWeight: 'bold',
              color: activeContractId === contract.id ? 'white' : 'black',
              backgroundColor: activeContractId === contract.id ? '#f39c12' : 'transparent',
              borderColor: activeContractId === contract.id ? '#f39c12' : 'rgba(0, 0, 0, 0.23)',
            }}
          >
            {contract.name}
          </Button>


        </TableCell>
        {/** u6me2      */}
        <TableCell style={{ borderRight: '1px solid black' }} align='center'>
          {contract.id === activeContractId ? (
            activeContractData.u6me2 === 1 ? (
              <>
                <CheckCircleRoundedIcon
                  style={{
                    fontSize: '1.25rem',
                    color: 'green',
                    marginRight: '0.5rem'
                  }}
                />
              </>
            ) : (
              <>
                <CancelRoundedIcon
                  style={{
                    fontSize: '1.25rem',
                    color: 'red',
                    marginRight: '0.5rem'
                  }}
                />
              </>
            )
          ) : (
            <span>-</span>
          )}
        </TableCell>
        {/** Circutor diferencial      */}
        <TableCell style={{ borderRight: '1px solid black' }} align='center'>
          {contract.id === activeContractId ? (
            activeContractData.differentialCircutor === 1 ? (
              <>
                <CheckCircleRoundedIcon
                  style={{
                    fontSize: '1.25rem',
                    color: 'green',
                    marginRight: '0.5rem'
                  }}
                />
              </>
            ) : (
              <>
                <CancelRoundedIcon
                  style={{
                    fontSize: '1.25rem',
                    color: 'red',
                    marginRight: '0.5rem'
                  }}
                />
              </>
            )
          ) : (
            <span>-</span>
          )}
        </TableCell>
        {/** Flag salidas adicionales      */}
        <TableCell style={{ borderRight: '1px solid black' }} align='center'>
          {contract.id === activeContractId ? (
            activeContractData?.additionalPanelOutputs >= 1 ? (
              <>
                <CheckCircleRoundedIcon
                  style={{
                    fontSize: '1.25rem',
                    color: 'green',
                    marginRight: '0.5rem'
                  }}
                />
              </>
            ) : (
              <>
                <CancelRoundedIcon
                  style={{
                    fontSize: '1.25rem',
                    color: 'red',
                    marginRight: '0.5rem'
                  }}
                />
              </>
            )
          ) : (
            <span>-</span>
          )}
        </TableCell>

        {/** Mantenimiento      */}
        <TableCell style={{ borderRight: '1px solid black' }} align='center'>
          {contract.id === activeContractId ? (
            activeContractData.maintenance === 1 ? (
              <>
                <CheckCircleRoundedIcon
                  style={{
                    fontSize: '1.25rem',
                    color: 'green',
                    marginRight: '0.5rem'
                  }}
                />
              </>
            ) : (
              <>
                <CancelRoundedIcon
                  style={{
                    fontSize: '1.25rem',
                    color: 'red',
                    marginRight: '0.5rem'
                  }}
                />
              </>
            )
          ) : (
            <span>-</span>
          )}

        </TableCell>
        {/** La fila expandible */}
      </TableRow >
      {contract?.id === activeContractId && (

        <TableRow sx={{
          backgroundColor: '#fdf2da',
        }}>
          <TableCell colSpan={5} sx={{ p: 0 }}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Grid container spacing={2} sx={{ mt: 0.1, ml: 0.1, mb: 2, mr: 0.1 }}>
                {(
                  activeContractData.u6me2 === 1 ||
                  activeContractData.differentialCircutor === 1 ||
                  activeContractData?.additionalPanelOutputs > 0
                ) ? (
                  <Grid item xs={3}>


                    <Typography fontWeight="bold"> Numero de equipos con : </Typography>
                    {activeContractData.u6me2 === 1 && (
                      <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginTop: "4px"
                      }}>
                        <Typography>
                          Tridonic :
                        </Typography>
                        <Chip label={countPanelsWithProfile(dataForU6me2).count} size='small'
                          onClick={() => handleActivatePanels(countPanelsWithProfile(dataForU6me2).ids)}></Chip>
                      </div>
                    )}
                    {activeContractData.differentialCircutor === 1 && (
                      <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginTop: "4px"
                      }}>
                        <Typography>
                          Relé diferencial circutor :
                        </Typography>
                        <Chip label={countPanelsWithProfile(dataForDifferentialCircutor).count} size='small'
                          onClick={() => handleActivatePanels(countPanelsWithProfile(dataForDifferentialCircutor).ids)}
                        >
                        </Chip>
                      </div>
                    )}
                    {activeContractData?.additionalPanelOutputs >= 1 && (
                      <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginTop: "4px"
                      }}>
                        <Typography>
                          Salidas adicionales :
                        </Typography>
                        <Chip
                          label={
                            activeContractData?.additionalPanelOutputs === 1
                              ? countPanelsWithProfile(dataForDigitalAdditionalOutputs).count
                              : activeContractData?.additionalPanelOutputs === 2
                                ? countPanelsWithProfile(dataForRelayAdditionalOutputs).count
                                : 0
                          }
                          size='small'
                          onClick={() => {
                            if (activeContractData?.additionalPanelOutputs == 1) {
                              handleActivatePanels(countPanelsWithProfile(dataForDigitalAdditionalOutputs).ids)

                            }
                            if (activeContractData?.additionalPanelOutputs == 2) {

                              handleActivatePanels(countPanelsWithProfile(dataForRelayAdditionalOutputs).ids)

                            }
                          }}
                        >
                        </Chip>
                      </div>
                    )}
                  </Grid>
                ) : (
                  <Grid item xs={1}>

                  </Grid>
                )}
                {(countNodesPerFirmware().length > 0 || countPanelsPerFirmware().length > 0) && (


                  <Grid item xs={8} textAlign={'center'}>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                      <Typography align="center" fontWeight="bold">
                        Versiones de firmware:
                      </Typography>
                      <Box sx={{ display: "flex", justifyContent: "center", gap: 12 }}>
                        {countPanelsPerFirmware().length > 0 && (
                          <Box>
                            <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
                              <Avatar
                                src={theme?.devicesIcons.panel.avatar}
                                alt="Node Icon"
                                style={{ width: '20px', height: '20px', }}

                              />
                            </Box>
                            {countPanelsPerFirmware().map((element, id) => (
                              <Box
                                key={id}
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                  mt: 0.5
                                }}
                              >
                                <span>-  {element.firmware_version}</span>
                                <ArrowRightAlt sx={{ color: "text.secondary" }} />
                                <Chip
                                  label={element.nDevices}
                                  size="small"
                                  onClick={() => handleActivatePanels(element.devicesIds)}
                                />
                                <Avatar
                                  src={theme?.devicesIcons.panel.avatar}
                                  alt="Panel Icon"
                                  sx={{ width: 20, height: 20 }}
                                />
                              </Box>
                            ))}
                          </Box>
                        )}
                        {countNodesPerFirmware().length > 0 && (
                          <Box >
                            <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
                              <Avatar
                                src={theme?.devicesIcons.node.avatar}
                                alt="Node Icon"
                                style={{ width: '20px', height: '20px', }}

                              />
                            </Box>
                            {countNodesPerFirmware().map((element, id) => (

                              <Box
                                key={id}
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                  mt: 0.5
                                }}
                              >
                                <span>-  {element.firmware_version}</span>

                                <ArrowRightAlt sx={{ color: "text.secondary" }} />

                                <Chip
                                  label={element.nDevices}
                                  size="small"
                                  onClick={() => handleActivateNodes(element.devicesIds)}
                                />

                                <Avatar
                                  src={theme?.devicesIcons.node.avatar}
                                  alt="Node Icon"
                                  sx={{ width: 20, height: 20 }}
                                />
                              </Box>
                            ))}
                          </Box>
                        )}
                      </Box>

                    </Box>
                  </Grid>
                )}
              </Grid>

            </Collapse>
          </TableCell>
        </TableRow >

      )
      }
    </>
  )
}
